var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isIncreasePercent)?_c('div',{class:_vm.isEqual ? '' : {
    'table-cell__incr': _vm.isIncrease,
    'table-cell__decr': _vm.isDecrease,
  }},[(!_vm.isEqual)?_c('i',{class:{
      'el-icon-caret-top': _vm.isIncrease,
      'el-icon-caret-bottom': _vm.isDecrease,
    }}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.value)+"%\n")]):_c('div',[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }